import React from "react";
import FlashcardSetGrid from "../components/FlashcardSetGrid";
import Header from "../components/Header";
import { withAuth } from "./withAuth";

function Dashboard({ sets, setSets }) {
  return (
    <div style={{ padding: "16px" }}>
      <Header />
      <FlashcardSetGrid sets={sets} setSets={setSets} />
    </div>
  );
}

export default withAuth(Dashboard);
